import { useState } from 'react';

import { QuietSuccessInterstitial } from '@/spaces/chat/panels/QuietSuccessInterstitial';

type Args = {
	title: string;
	summary: string;
	onClose: () => void;
	onGoToNextStep: () => void;
};

export const useStepSubmitted = ({
	title,
	summary,
	onClose,
	onGoToNextStep,
}: Args) => {
	const [isSubmitted, setIsSubmitted] = useState(false);
	const submittedView = isSubmitted ? (
		<QuietSuccessInterstitial
			title={title}
			summary={summary}
			secondaryAction={{ label: 'Close', onPress: onClose }}
			primaryAction={{ label: 'Go to next step', onPress: onGoToNextStep }}
		/>
	) : null;
	return {
		isSubmitted,
		markSubmitted: () => setIsSubmitted(true),
		submittedView,
	};
};
